// Mirrors the copy-count selection already used by CWHardwareController.js / hardWareControllerPrinter.js,
// so the plain-browser (window.print/XML) paths honor the same Till Template configuration.
const getReceiptCopies = (printReciptData, posConfig) => {
  const isLoyaltyPayment =
    (printReciptData.payments && printReciptData.payments.some((payment) => payment.isloyalty)) ||
    (printReciptData?.paymentData && printReciptData?.paymentData.some((payment) => payment?.isloyalty));

  let copies;
  if (printReciptData.isReturn) {
    copies = posConfig?.return_receipt_copies;
  } else if (printReciptData.layAway === "Y" || printReciptData.layAway === true) {
    copies = printReciptData.paid === 0 ? posConfig?.layaway_receipt_copies : posConfig?.layaway_paid_receipt_copies;
  } else if (isLoyaltyPayment) {
    copies = posConfig?.loyalty_receipt_copies;
  } else {
    copies = posConfig?.sales_receipt_copies;
  }

  // TEMP diagnostic for BUG-1740 recurrence — remove once confirmed.
  console.debug("[BUG-1740][getReceiptCopies]", {
    isReturn: printReciptData.isReturn,
    layAway: printReciptData.layAway,
    paid: printReciptData.paid,
    isLoyaltyPayment,
    sales_receipt_copies: posConfig?.sales_receipt_copies,
    return_receipt_copies: posConfig?.return_receipt_copies,
    layaway_receipt_copies: posConfig?.layaway_receipt_copies,
    layaway_paid_receipt_copies: posConfig?.layaway_paid_receipt_copies,
    loyalty_receipt_copies: posConfig?.loyalty_receipt_copies,
    resolvedCopies: copies,
  });

  return copies > 0 ? copies : 1;
};

export default getReceiptCopies;
